import { Icon, Menu } from 'antd';
import React from 'react';
import TiledTitleList from '../Titles/TiledTitleList';
import { useReviews } from './containers/ReviewsDataStore';
import ReviewType from './ReviewType';

export default function ReviewsMenu() {
	const reviewsDataStore = useReviews();
	const { isLoading, reviews, selectedMenuOption } = reviewsDataStore.state;

	const renderReviews = () => {
		const filteredReviews = getReviewsByRating(
			ReviewType[selectedMenuOption],
		);
		var skus = filteredReviews.map(item => item.sku);
		return (
			reviews && (
				<TiledTitleList
					skus={skus}
					isLoading={isLoading}
					titles={filteredReviews}
					listKey={selectedMenuOption}
				/>
			)
		);
	};

	const renderMenuItem = reviewType => {
		const count = getReviewsByRating(reviewType).length;
		return (
			(count > 0 || reviewType.doShowIfZero) && (
				<Menu.Item key={reviewType.key}>
					<Icon type={reviewType.key} />
					<b>{count}</b> {reviewType.text}
				</Menu.Item>
			)
		);
	};

	const getReviewsByRating = reviewType => {
		var filteredReviews = reviews;
		if (!reviewType.dontFilter) {
			filteredReviews =
				reviews &&
				reviews.filter(
					rv =>
						rv.rating >= reviewType.lowRating &&
						rv.rating <= reviewType.highRating,
				);
		}
		return filteredReviews;
	};

	const handleClick = e => {
		reviewsDataStore.setSelectedMenuOption(e.key);
	};

	return (
		<>
			<div>
				<Menu
					onClick={handleClick}
					selectedKeys={[selectedMenuOption]}
					mode="horizontal">
					{Object.keys(ReviewType).map(reviewType =>
						renderMenuItem(ReviewType[reviewType]),
					)}
				</Menu>
			</div>
			{renderReviews()}
		</>
	);
}
